import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class Frui_qpxhPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { frui_qpxhPage,currentFrui_qpxh} = this.props.user;
     this.fetchList( frui_qpxhPage);
  }

  fetchList = (page,values) => {
    const {getFrui_qpxhList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getFrui_qpxhList(params);
  }

  getDataSource() {
    const { user } = this.props;
    const { frui_qpxhById, frui_qpxhList } = user;
    if (!frui_qpxhList) return [];
    return frui_qpxhList.map(id => frui_qpxhById[id]);
  }

  get listProps() {
    const { user,actions } = this.props
    const { getFrui_qpxhListPending,frui_qpxhTotal,frui_qpxhPage } = user
    const { deleteFrui_qpxh,chooseCurrentFrui_qpxh,frui_qpxhModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpxhListPending,
      columns:[
        {
          title: "开放平台应用",
          dataIndex: 'shopName',
          key: 'shopName',
          width: 180,
        },
      ],
      pagination:{
        total:frui_qpxhTotal,
        current:frui_qpxhPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentFrui_qpxh(record);
          frui_qpxhModalChange(true,"updata");
        }else if(item.key == 3){
            deleteFrui_qpxh(record.id).then((data) => {
            this.fetchList(frui_qpxhPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { user,actions } = this.props
    const { currentFrui_qpxh, frui_qpxhModalVisible,frui_qpxhPage, frui_qpxhModalType,submitFrui_qpxhPending } = user

    const { frui_qpxhModalChange,submitFrui_qpxh } = actions;
    const editItem  = frui_qpxhModalType === 'create' ? {} : currentFrui_qpxh
    return {
      item: frui_qpxhModalType === 'create' ? {} : currentFrui_qpxh,
      visible: frui_qpxhModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_qpxhPending,
      title: `${
        frui_qpxhModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "shopName",
          label: "商户名",
          // initialValue: editItem.shopName,
          widget: Input,
          required: true
        },
        {
          key: "score",
          label: "score",
          // initialValue: editItem.score,
          widget: Input,
          required: true
        },
        {
          key: "subAppid",
          label: "商户公众号id",
          // initialValue: editItem.subAppid,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitFrui_qpxh(Object.assign({},data,{})).then(data=> {
          frui_qpxhModalChange(false,"create");
          this.fetchList(frui_qpxhPage);
        })
      },
      onCancel() {
        frui_qpxhModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,user } = this.props
    const { currentFrui_qpxh,frui_qpxhPage} = user
    const { frui_qpxhModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "loginId",
            widget: Input,
            widgetProps:{
                placeholder:"请输入登录名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        frui_qpxhModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,user } = this.props
    const { currentFrui_qpxh,frui_qpxhPage} = user
    const { frui_qpxhModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ frui_qpxhModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_qpxhPage);


// WEBPACK FOOTER //
// ./src/features/user/Frui_qpxhPage.js